var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0578251 9.87682L0.570424 5.74704C0.882696 4.27342 1.76649 3.66699 2.60903 3.66699H9.37886C10.2332 3.66699 11.1464 4.23097 11.4116 5.74704L11.9301 9.87682C12.3543 12.909 10.7929 13.667 8.75431 13.667H3.22768C1.19497 13.667 -0.319258 12.5694 0.0578251 9.87682ZM7.93533 7.09945C8.26074 7.09945 8.52453 6.82795 8.52453 6.49302C8.52453 6.1581 8.26074 5.8866 7.93533 5.8866C7.60993 5.8866 7.34614 6.1581 7.34614 6.49302C7.34614 6.82795 7.60993 7.09945 7.93533 7.09945ZM4.66531 6.49302C4.66531 6.82795 4.40152 7.09945 4.07611 7.09945C3.75071 7.09945 3.48692 6.82795 3.48692 6.49302C3.48692 6.1581 3.75071 5.8866 4.07611 5.8866C4.40152 5.8866 4.66531 6.1581 4.66531 6.49302Z",
    fill: "#ffbb00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M2.68425 3.51638C2.68216 3.56809 2.69209 3.61958 2.71328 3.66683H3.67136C3.68991 3.61879 3.69974 3.56785 3.70039 3.51638C3.70039 2.23805 4.74026 1.20175 6.023 1.20175C7.30574 1.20175 8.3456 2.23805 8.3456 3.51638C8.33681 3.56615 8.33681 3.61706 8.3456 3.66683H9.3269C9.33569 3.61706 9.33569 3.56615 9.3269 3.51638C9.25235 1.73744 7.7835 0.333496 5.99687 0.333496C4.21023 0.333496 2.74139 1.73744 2.66683 3.51638H2.68425Z",
    fill: "#ffbb00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIcon);
export default __webpack_public_path__ + "static/media/cart-icon.631c05566b771575111054bc5b60ec44.svg";
export { ForwardRef as ReactComponent };